import React from 'react';

export default function PreviewCheck() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', background: '#0b3d0b', color: '#fff',
      textAlign: 'center', padding: 24
    }} data-testid="preview-check-page">
      <div style={{ fontSize: 72, marginBottom: 16 }}>{'\u2705'}</div>
      <h1 style={{ fontSize: 42, fontWeight: 900, color: '#7CFC00', marginBottom: 12 }}>
        PREVIEW IS WORKING
      </h1>
      <p style={{ fontSize: 20, maxWidth: 520 }}>
        You are on the PREVIEW workshop site. Everything is running.
      </p>
      <p style={{ fontSize: 16, marginTop: 20, opacity: 0.8 }}>
        Page loaded at: {new Date().toLocaleString()}
      </p>
      <a href="/" style={{ marginTop: 30, color: '#FFCC00', fontSize: 18, fontWeight: 700 }}>
        Go to the Home page {'\u2192'}
      </a>
    </div>
  );
}
